export const camelCaseToSpace = (value) => {
  return value.replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, str => str.toUpperCase())
}
